import './styles.scss';

const Input = ({ placeholder, type, readonly, meta: { touched, error }, input, ...rest }) => (
  <div className="input">
    {readonly && <input {...rest} placeholder={placeholder} type={type} readOnly />}
    {!readonly && <input {...input} {...rest} placeholder={placeholder} type={type} />}
    {touched && error && <span>{error}</span>}
  </div>
);

export default Input;
